export default function Pandas_Certificate() {
  return <div>Pandas_Certificate </div>;
}
